/**
 * @param {unknown} response
 * @returns {boolean}
 */
export function isSiteAvailable(response) {
    return response?.available === true;
}

/**
 * @param {unknown} response
 * @returns {string | null}
 */
export function getMaintenanceMessage(response) {
    const message = response?.message;

    if (typeof message !== 'string') {
        return null;
    }

    const trimmed = message.trim();

    return trimmed || null;
}
